var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowright = function SvgArrowright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.154 6.004a.63.63 0 000 .825.486.486 0 00.74 0l2.62-2.917a.63.63 0 000-.824L.893.17a.486.486 0 00-.74 0 .63.63 0 000 .825L2.402 3.5.154 6.004z",
    fill: "#170426"
  })));
};
export default SvgArrowright;